import cookies from 'js-cookie';
import { message } from "antd";
import {$t} from "@/i18n";


export const getLang = () => {
    let routeLang = window.location.pathname.substr(1, 5);
    let lang = (/(\w+)[-](\w+)/.test(routeLang) ? routeLang : localStorage.lang) || 'en-us';
    return lang;
};
export const i18nList = {
    "en-us": "English",
    "zh-cn": "简体中文",
    "zh-tc": "繁體中文",
    "ru-ru": "Русский",
    "fr-fr": "Français",
    "es-es": "Español (España)",
    "es-la": "Español (Latinoamérica)",
    "tr-tr": "Türkçe",
    "vi-vi": "Tiếng Việt",
    "pt-pt": "Português (Portugal)",
    "it-it": "Italiano",
    "uk-ua": "Українська",
    "id-id": "Bahasa Indonesia",

}

export const acceptLangList = Object.keys(i18nList);

export function downLoadByUrl(url){
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader("HB-UC-TOKEN", cookies.get('HB-UC-TOKEN') || '');
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
        console.log(e);
        if (this.status === 200) {
            const blob = this.response;
            const filename = "123.xls";
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.href = url;
            a.download=filename;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    };
    xhr.send();
}

export function downLoadByUrlPost(url,data,title){
    const xhr = new XMLHttpRequest();
    xhr.open('post', url, true);
    const token = cookies.get('HB-UC-TOKEN') || sessionStorage.getItem('HB-UC-TOKEN') || '';
    xhr.setRequestHeader("HB-UC-TOKEN", token);
    xhr.setRequestHeader('content-type', 'application/json');
    // xhr.responseType = 'blob';
    xhr.onload = function (e) {
        // console.log('downLoadByUrlPost',e);
        // debugger
        if (this.status === 200) {
            const res = JSON.parse(this.response);
            console.log('downLoadByUrlPost return ',res);
            // console.log('downLoadByUrlPost return ',res.code);
            if (res.code === 200) {
                message.info($t("{#文件导出中，1~30分钟后可在【下载文档】中下载，导出后将通过邮件通知您，文件下载链接保留7天，请尽快下载。#}"))
             }
            else if (res.code === 1001) {
                message.error($t("{#加载失败 请稍后重试#}"))
            } else if (res.code === 10601) {
                message.error($t("{#已超出每月导出上限，每张表最多导出60次/月。#}"))
            } else if (res.code === 10704) {
                message.error($t("{#7天内已下载过该数据，请到已下载列表查看。#}"))
            } else {
                message.error(res.message || $t("{#加载失败 请稍后重试#}"))
            }
            
        } else {
            message.error($t("{#加载失败 请稍后重试#}"))
            // 加载失败 请稍后重试
        }
    };
    xhr.onerror = function (e) {
        message.error($t("{#加载失败 请稍后重试#}"))
    }
    const sendData = {...data};
    xhr.send(JSON.stringify(sendData));
}


export function downLoadByUrlPostV2(url,data,title){
    const xhr = new XMLHttpRequest();
    xhr.open('post', url, true);
    const token = cookies.get('HB-UC-TOKEN') || sessionStorage.getItem('HB-UC-TOKEN') || '';
    xhr.setRequestHeader("HB-UC-TOKEN", token);
    xhr.setRequestHeader('content-type', 'application/json');
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
        // debugger
        console.log('downLoadByUrlPostV2',e);
        // debugger
        if (this.status === 200) {
            // const res = JSON.parse(this.response);
            // console.log('downLoadByUrlPost return ',res);
            // console.log('downLoadByUrlPost return ',res.code);
            // if (res.code === 200) {
                
            // }
            // else if (res.code === 1001) {
            //     message.error($t("{#加载失败 请稍后重试#}"))
            // } else if (res.code === 10601) {
            //     message.error($t("{#已超出每月导出上限，每张表最多导出60次/月。#}"))
            // } else if (res.code === 10701) {
            //     message.error($t("{#7天内已下载过该数据，请到已下载列表查看。#}"))
            // } else if (res.code === 10702) {
            //     message.error($t("{#加载失败 请稍后重试#}"))
            // } else if (res.code === 10703) {
            //     message.error($t("{#加载失败 请稍后重试#}"))
            // } else if (res.code === 10704) {
            //     message.error($t("{#加载失败 请稍后重试#}"))
            // }

            const blob = this.response;
            const filename = title + ".xls";
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.href = url;
            a.download=filename;
            a.click();
            window.URL.revokeObjectURL(url);
        } else {
            message.error($t("{#加载失败 请稍后重试#}"))
            // 加载失败 请稍后重试
        }
    };
    const sendData = {...data};
    xhr.send(JSON.stringify(sendData));
}